import { gql } from "graphql-request";

const SERVER_DELETE_HOLIDAY = gql`
  mutation SERVER_DeleteHoliday($id: ID!) {
  deleteHoliday(id: $id)
}
`;
export default SERVER_DELETE_HOLIDAY;
